export class StockTrnHDModel{
  hedtype = '' ;
  hedserial = 0 ;
  heddate = '2024-01-01' ;
  hedsup_client = '' ;
  hedroomnumber = '' ;
  hedprogramno = '' ;
  hedtax1 = '' ;
  hedtax2 = '' ;
  heddisc1 = 0 ;
  heddisc2 = 0 ;
  hedstore = '' ;
  hedtostore = '' ;
  heddoctor = '' ;
  heddescription = '' ;
  hedpost = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;
  patientName = '';
  PatientFName = '';

}
export class StockTrnDetModel{
  dettype = '' ;
  detserial = 0 ;
  detline = 0 ;
  detitem = '' ;
  detitemname = '' ;
  detqty = 0 ;
  detprice = 0 ;
  detvalue = 0 ;
  detdescription = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;

}
